import React from 'react';
import PropTypes from 'prop-types';

import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import { Container, Flex, Text } from '@chakra-ui/react';
import Link from '@repo/ui-components/tailwind/Link';

export default function TextHeroesDefault({ block }) {
  const { headline, copy, links } = block;

  return (
    <Container
      {...generateSectionId(block)}
      pb={{ base: 6, lg: 10 }}
      pt={{ base: 6, lg: 16 }}
    >
      <Flex
        justify="space-between"
        align={{ base: 'flex-start', lg: 'end' }}
        flexDir={{ base: 'column', lg: 'row' }}
        gap={{ base: 4, md: 8 }}
      >
        <Flex flexDir="column">
          <Text
            as="h1"
            textStyle="h1"
            color="brand.ink"
            css={{ wordBreak: 'break-word' }}
          >
            {headline}
          </Text>
          {copy?.length && (
            <Text textStyle="h3" fontWeight="bold" color="typography.light">
              {copy}
            </Text>
          )}
        </Flex>
        {links?.length > 0 && (
          <Flex
            gap={{ base: 8, md: 10 }}
            overflowX={{ base: 'auto', md: 'visible' }}
            w={{ base: '100%', md: 'auto' }}
            py={4}
          >
            {links.map(link => (
              <Link
                className="text-brand-foreground whitespace-nowrap xl:whitespace-normal"
                key={link._key}
                link={link}
              >
                {link?.caption}
              </Link>
            ))}
          </Flex>
        )}
      </Flex>
    </Container>
  );
}

TextHeroesDefault.propTypes = {
  block: PropTypes.shape({
    _type: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    copy: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string.isRequired,
        caption: PropTypes.string.isRequired,
        linkType: PropTypes.string.isRequired,
        href: PropTypes.string,
      })
    ),
  }).isRequired,
};
